import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import {
  FormControl,
  Slide,
  Snackbar,
  MenuItem,
  Grid,
  DialogActions,
  DialogContent,
  Alert,
  Dialog,
  Select,
  Box,
  Tooltip,
  IconButton,
} from "@mui/material";
import { ContentCopy, Refresh } from "@mui/icons-material";
import { CopyToClipboard } from "react-copy-to-clipboard";

import {
  cardBodyStyle,
  ButtonLoadinStyle,
  ButtonExit,
  ParagraphTextPage,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function TokenKeysAdmin(props) {
  const classes = useStyles();

  const [openAlertSuccess, setopenAlertSuccess] = useState(false);
  const [mensaje_success, setmensaje_success] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [disable, setDisable] = useState(true);
  const [loader, setLoader] = useState(false);
  const [activateChange, setActivateChange] = useState(
    props.id.row.statusTokenKey || ""
  );

  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });
  const [copied, setCopied] = useState(false);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    token: props.id.row.tokenKey || "",
  });

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = (e) => {
    e.preventDefault();
    setError(false);
    setopenAlertSuccess(false);

    if (values.token === "") {
      setValues({ ...values, errorPercentage: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe generar una llave secreta si desea activar",
      });
      return;
    }

    if (activateChange === "") {
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe seleccionar un estado si habilitar o deshabilitar",
      });
      return;
    }

    setLoader(true);

    const dataValue = {
      tokenKey: values.token,
      statusTokenKey: parseInt(activateChange),
    };

    axios
      .put(`${urlServices}clients/${props.id.id}`, dataValue, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then((response) => {
        setDisable(true);
        setopenAlertSuccess(true);
        setmensaje_success("Registro guardado con éxito.");
        props.callBackRefresh();
        setLoader(false);
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ..."
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
        setLoader(false);
      });
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  // Función para formatear el token (mostrar primeros 4 y últimos 4 caracteres)

  const formatToken = (token) => {
    if (!token) return "";
    if (token.length <= 30) return token;

    const firstFour = token.substring(0, 7);
    const lastFour = token.substring(token.length - 7);
    return `${firstFour}......................${lastFour}`;
  };

  // Función para generar un token aleatorio
  const generateToken = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const length = 32; // Longitud típica para tokens API

    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }

    setValues((prevValues) => ({
      ...prevValues,
      token: result,
    }));

    setDisable(false);
  };

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleActivateChange = (event) => {
    const selectedValue = event.target.value;
    setActivateChange(selectedValue);
    setDisable(false);
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    {error && <Alert severity="error">{mensageSystem}</Alert>}
                    <div className={classes.titleCardFilter}>
                      Generar llave secreta
                    </div>
                    <div className={classes.lineBottom}></div>
                    <ParagraphTextPage style={{ fontSize: 12, marginTop: 5 }}>
                      Una vez que haya generado y habilitado la llave secreta
                      para el cliente, deberá copiarla y pegarla en la
                      configuración del sistema externo que utilice para
                      conectarse a BOOKNPAYS de este mismo cliente.
                    </ParagraphTextPage>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={10}
                    sx={{ background: "#fff", borderRadius: 3 }}
                  >
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <span
                          style={{
                            color: "#000",
                            fontWeight: 580,
                            fontSize: 16,
                          }}
                        >
                          Llave secreta:{" "}
                          <span style={{ fontWeight: 500 }}>
                            {formatToken(values.token)}
                          </span>
                        </span>

                        {/* Botón para copiar token */}
                        {values.token && (
                          <CopyToClipboard
                            text={values.token}
                            onCopy={handleCopy}
                          >
                            <Tooltip
                              title={copied ? "¡Copiado!" : "Copiar token"}
                            >
                              <IconButton edge="end" size="small">
                                <ContentCopy />
                              </IconButton>
                            </Tooltip>
                          </CopyToClipboard>
                        )}

                        {/* Botón para generar nuevo token */}
                        <Tooltip title="Generar nuevo token">
                          <IconButton
                            onClick={generateToken}
                            edge="end"
                            size="small"
                            color="primary"
                          >
                            <Refresh />
                          </IconButton>
                        </Tooltip>
                      </Box>

                      <Alert severity="info" sx={{ fontSize: 12 }}>
                        Token para integración con APIs externas.
                      </Alert>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} sx={{ mt: 1 }}>
                    <span style={{ color: "#000", fontWeight: 500 }}>
                      Habilitar o deshabilitar:
                    </span>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth size="small">
                      <Select
                        value={activateChange}
                        // label="Unidades"
                        onChange={handleActivateChange}
                      >
                        <MenuItem key="1" value="1">
                          Habilitar
                        </MenuItem>
                        <MenuItem key="0" value="0">
                          Deshabilitar
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {activateChange !== "0" && props.id.row.statusTokenKey === 1 && (
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          textAlign: "center",
                          fontSize: 11,
                          fontWeight: "bold",
                          width: 70,
                          p: 1,
                          background: "rgb(237, 247, 237)",
                          color: "rgb(30, 70, 32)",
                          borderRadius: 5,
                        }}
                      >
                        ACTIVO
                      </Box>
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12}>
                    <br></br>
                    <center>
                      <ButtonLoadinStyle
                        type="submit"
                        onClick={submitForm}
                        disabled={disable}
                        loading={loader}
                        // loadingIndicator="Registrando…"
                        variant="outlined"
                      >
                        Guardar
                      </ButtonLoadinStyle>
                    </center>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <center>
                      {openAlertSuccess && (
                        <Alert severity="success">{mensaje_success}</Alert>
                      )}
                    </center>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {alert.openAlert && (
              <Snackbar
                open={true}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={handleCloseAlert}
              >
                <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                  <Alert
                    onClose={handleCloseAlert}
                    severity={
                      alert.errorAlert === "error" ? "error" : "success"
                    }
                    elevation={6}
                    variant="filled"
                  >
                    {alert.mensaje}
                  </Alert>
                </Slide>
              </Snackbar>
            )}
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
